import React from 'react';
import PropTypes from 'prop-types';

function ButtonCircleAdd(props) {
  const { onClick } = props;
  return <button {...props} type="button" className="add" onClick={onClick} />;
}

ButtonCircleAdd.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ButtonCircleAdd;
